import { render, staticRenderFns } from "./JobAccountFormStepDocuments.vue?vue&type=template&id=4bbb4096"
import script from "./JobAccountFormStepDocuments.vue?vue&type=script&lang=js"
export * from "./JobAccountFormStepDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports